import styled from 'styled-components';
import tw from 'twin.macro';
import PropTypes from 'prop-types';

const List = styled.div.attrs((props) => ({
  role: 'list',
  $withLeftPadding: props.$withLeftPadding ?? false,
  $withLeftMargin: props.$withLeftMargin ?? false,
  $withPadding: props.$withPadding ?? true
}))(({ $withLeftPadding, $withLeftMargin, $withPadding }) => [
  $withLeftPadding && tw`pl-4`,
  $withLeftMargin && tw`ml-4`,
  $withPadding && tw`p-16`
]);

List.propTypes = {
  $withLeftPadding: PropTypes.bool,
  $withLeftMargin: PropTypes.bool
};

export default List;
